/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 *
 * Per-browser memory of "Was dit artikel nuttig?" votes so a reader votes at
 * most once per article. Mirrors the reviewFlagMemory.ts localStorage
 * pattern: SSR-safe (typeof window guard), private-mode-safe (try/catch).
 */

export type HelpfulVote = 'yes' | 'no';

const storageKey = (articleId: string) => `ere_article_helpful_${articleId}`;

export function getStoredHelpfulVote(articleId: string): HelpfulVote | null {
  if (typeof window === 'undefined') return null;
  try {
    const v = window.localStorage.getItem(storageKey(articleId));
    return v === 'yes' || v === 'no' ? v : null;
  } catch {
    return null;
  }
}

export function storeHelpfulVote(articleId: string, vote: HelpfulVote): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(storageKey(articleId), vote);
  } catch {
    /* private mode / quota exceeded — vote still registers in analytics */
  }
}
